<template>
  <div>
    <popup-add-task category="sm" ref="popupAddTask" />
    <vs-row vs-justify="center" class="items-center mt-8 mb-4">
      <vs-button radius color="primary" icon="chevron_left" @click="handlePrevWeek"></vs-button>
      <h5 class="mx-4">Venue tasks for {{ weekTitle }}</h5>
      <vs-button radius color="primary" icon="chevron_right" @click="handleNextWeek"></vs-button>
    </vs-row>

    <vs-row class="mt-6 days-container" vs-justify="center">
      <vs-col vs-w="3" class="px-2" style="position: relative" v-for="dayInfo in weekList" :key="dayInfo.index">
        <vs-card>
          <center>
            <div :class="{ bold: dayInfo.isToday }">
              <span class="day-title">{{ dayInfo.day }}</span>
              <feather-icon style="cursor: pointer; float: right" icon="PlusCircleIcon"
                svgClasses="h-5 w-5 stroke-current text-primary" @click="$refs.popupAddTask.show(dayInfo.date)" />
            </div>
          </center>
          <vs-list class="days-task-list mt-4 p-0">
            <tasks-day :tasks="tasksForVenue" :date="dayInfo.date" :showCompleted="true" />
          </vs-list>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Question from "../MeetingQuestion.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import TasksDay from "@/views/modules/vp/venueTasks/components/TasksDay.vue";
import PopupAddTask from "@/views/modules/vp/venueTasks/components/PopupAddTask.vue";

export default {
  props: ["step", "meetingInstance"],
  components: { Question, TasksDay, PopupAddTask },
  data() {
    return {
      currentWeekDate: this.getLastWeekOfPeriod(this.meetingInstance)
    };
  },
  mounted() {
    this.$root.$on("venueTaskChanged", this.fetchTasksForWeek);

    this.fetchTasksForWeek();
  },
  methods: {
    getLastWeekOfPeriod(meetingInstance) {
      const meetingType = meetingInstance.meeting.type;
      const year = meetingInstance.whenYear;

      // Calculate the last week of the period, based on the meeting type
      switch (meetingType) {
        case "Monthly": {
          console.log(
            "MONTHLY calculation",
            meetingInstance.when,
            meetingInstance.whenYear,
            year,
            "result",
            moment()
              .month(meetingInstance.when - 1)
              .year(year)
              .endOf("month")
              .day("Monday")
              .toDate()
          );
          return moment()
            .month(meetingInstance.when - 1)
            .year(year)
            .endOf("month")
            .day("Monday")
            .toDate();
        }
        case "Quarterly": {
          const quarterEndMonth = meetingInstance.when * 3;
          return moment()
            .month(quarterEndMonth - 1)
            .year(year)
            .endOf("month")
            .day("Monday")
            .toDate();
        }
        case "Annually": {
          return moment().month(11).year(year).endOf("year").day("Monday").toDate();
        }
        case "BiAnnually": {
          const biannualMonth = meetingInstance.when === 0 ? 5 : 11; // June or December
          return moment().month(biannualMonth).year(year).endOf("month").day("Monday").toDate();
        }
        case "Weekly": {
          return moment()
            .year(year)
            .week(meetingInstance.when)
            .day("Monday")
            .toDate();
        }
        case "BiWeekly": {
          return moment()
            .year(year)
            .week(meetingInstance.when)
            .day("Monday")
            .toDate();
        }
        default: {
          throw new Error("Invalid meeting type");
        }
      }
    },
    async fetchTasksForWeek() {
      console.log("FETCHING for week", this.meetingInstance.venueId);
      await this.$store.dispatch("venueTasks/getVenueTasks", {
        venueId: this.meetingInstance.venueId,
        year: moment(this.currentWeekDate).format("yyyy"),
        week: moment(this.currentWeekDate).format("W")
      });
    },
    handlePrevWeek() {
      this.currentWeekDate = moment(this.currentWeekDate).subtract(1, "weeks").toDate();
      this.fetchTasksForWeek();
    },
    handleNextWeek() {
      this.currentWeekDate = moment(this.currentWeekDate).add(1, "weeks").toDate();
      this.fetchTasksForWeek();
    }
  },
  computed: {
    ...mapGetters({
      tasks: "venueTasks/tasks"
    }),
    tasksForVenue() {
      return this.tasks.filter(e => e.venueIds.includes(this.meetingInstance.venueId));
    },

    weekTitle() {
      var date = moment(this.currentWeekDate); // TODO maybe use monday specifically?
      return `Week ${date.isoWeek()}, ${date.format("MMM YYYY")}`;
    },

    getYear() {
      return moment(this.meetingInstance.createdAction.timestamp).format("yyyy");
    },
    getMonth() {
      return moment()
        .day("Monday")
        .week(this.meetingInstance.when + 1)
        .year(this.getYear)
        .format("MMMM");
    },

    weekList() {
      var date = moment(this.currentWeekDate);

      var weekStart = date.clone().startOf("isoWeek").startOf("day");

      var days = [];
      for (var i = 0; i < 7; i++) {
        days.push({
          index: i,
          day: moment(weekStart).add(i, "days").format("dddd Do"),
          date: moment(weekStart).add(i, "days").clone(),
          isToday: moment(weekStart).add(i, "days").isSame(moment(), "day")
        });
      }

      return days;
    }
  }
};
</script>

